import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import { getServerList } from "@/api/data";
export default {
  props: {
    value: [String, Array, Number],
    multiple: Boolean,
    readCacheType: Number,
    //不读缓存是1，读缓存是随便只要不等于1就可以
    type: Number,
    //1的时候是单选，不传就是多选
    all: Boolean,
    //是否增加全部区服
    isCache: Boolean
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        this.label = newVal;
      }
    }
  },
  data: function data() {
    return {
      serverList: [],
      label: this.value,
      prop_selopList: [],
      prop_mutSelList: "",
      cache_key: "",
      checked: false
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.initCacheKey();
            _this.loadServerList();
            _this.showSelectOptions();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initCacheKey: function initCacheKey() {
      if (this.isCache || this.readCacheType == 2) {
        if (this.multiple && this.multiple === true) {
          this.cache_key = "select_server_mult";
        } else {
          this.cache_key = "select_server";
        }
        if (this.all) {
          this.cache_key += "_all";
        }
      }
    },
    //获取选择框下拉列表
    loadServerList: function loadServerList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getServerList();
            case 2:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.serverList = res.data;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    selectAll: function selectAll() {
      var _this3 = this;
      if (this.checked) {
        this.serverList.map(function (item) {
          _this3.label.push(item.id);
        });
      } else {
        this.label = [];
      }
      if (this.isCache || this.readCacheType == 2) {
        this.localCache.setCache(this.cache_key, this.label);
      }
      this.$emit("input", this.label);
    },
    someSelect: function someSelect(val) {
      if (this.multiple && this.multiple === true) {
        if (val.length === this.serverList.length) {
          this.checked = true;
        } else {
          for (var i = 0; i < val.length; i++) {
            if (val[i] == "0") {
              this.label = val.splice(i, 1);
            }
          }
          this.checked = false;
        }
      }
      if (this.isCache || this.readCacheType == 2) {
        this.localCache.setCache(this.cache_key, this.label);
      }
      this.$emit("input", val);
    },
    showSelectOptions: function showSelectOptions() {
      if (this.isCache || this.readCacheType == 2) {
        this.label = this.localCache.getCache(this.cache_key, this.multiple);
        if (this.multiple && this.multiple === true) {
          for (var i = 0; i < this.label.length; i++) {
            if (this.label[i] == "") {
              this.label = [];
            }
          }
        }
      }
      this.$emit("input", this.label);
    }
  }
};